const recommendListModule = {
  state: {
    recommendedList: []
  },
  mutations: {
    recommendListModuleUpdateRecommendedList (state, playList) {
      if (typeof playList === 'object') {
        let index = 0
        let result = []
        Object.keys(playList).map(function (key) {
          result[index] = playList[key]
          index = index + 1
        })
        playList = result
      }
      state.recommendedList = playList
    }
  },
  getters: {
    recommendListModuleGetRecommendedList (state) {
      return state.recommendedList
    }
  }
}
export default recommendListModule



// WEBPACK FOOTER //
// ./src/store/RecommendListModule.js